import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
    selector: 'collapsible-panel',
    templateUrl: './collapsible-panel.component.html',
    styleUrls: ['./collapsible-panel.component.scss'],
    standalone: false
})
export class CollapsiblePanelComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  title: string;

  @Input()
  IsCollapsed: boolean = false;

  private collapsiblePanelsKey = 'CollapsiblePanels';
  private _isCollapsed = false;

  constructor(private localStorageService: LocalStorageService) {
  }

  ngOnInit() {
    if (this.IsCollapsed) {
      this.fncollapsiblePanels(true);
    }

    const collapsiblePanels = this.localStorageService.retrieve(this.collapsiblePanelsKey);
    if (collapsiblePanels && this.name in collapsiblePanels) {
      this.isCollapsed = collapsiblePanels[this.name];
    }
  }

  get isCollapsed() {
    return this._isCollapsed;
  }

  set isCollapsed(value: boolean) {
    this.fncollapsiblePanels(value);
  }
  fncollapsiblePanels(value: boolean) {
    this._isCollapsed = value;

    // Update isCollapsed state in localStorage
    let collapsiblePanels = this.localStorageService.retrieve(this.collapsiblePanelsKey);
    if (!collapsiblePanels) {
      collapsiblePanels = {};
    }

    collapsiblePanels[this.name] = value;
    if (!this.IsCollapsed)
    this.localStorageService.store(this.collapsiblePanelsKey, collapsiblePanels);
  }
}
